import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import { IStore } from 'redux/store';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type CompassErrorCoverPageProps = PropsFromRedux & OwnProps;
function CompassErrorCoverPage(props: CompassErrorCoverPageProps) {
    const { vesselInfo, dateRange, selectedDate, globalSettings } = props;
    const compassErrorData = {
        mt: vesselInfo?.vesselName,
        callSign: vesselInfo?.callSign,
        officialNo: globalSettings?.gmddsRadioLogSectionA?.officialNo,
    };

    const { mt, callSign, officialNo} = compassErrorData;
    return (
        <div>
            {/* First page */}
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="font-medium text-center text-xl my-24 mx-0">
                    <h2 className="uppercase text-2xl">COMPASS ERROR LOG</h2>
                </div>
                <div className="flex justify-center mt-8 mb-32">
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Vessel Name:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {mt}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Call Sign:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {callSign}
                            </p>
                        </div>

                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Official No:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {officialNo}
                            </p>
                        </div>
                        <div
                            className="flex justify-between items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center  mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period From :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {selectedDate &&
                                        moment(selectedDate).format(
                                            'DD-MM-yyyy'
                                        )}{' '}
                                </p>{' '}
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">To :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {selectedDate &&
                                        moment(selectedDate).format(
                                            'DD-MM-yyyy'
                                        )}
                                </p>{' '}
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                English
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Second page */}
            <div className="print-page-break">
                <h2 className="text-center font-semibold text-2xl underline pt-10">
                    COMPASS ERROR LOG
                </h2>
                <h4 className="text-lg font-semibold text-center mb-12">
                    INSTRUCTION FOR FILLING UP THE LOG:
                </h4>
                <div className="flex justify-center mb-12">
                    <div className="w-2/3">
                        <ol className="list-decimal ml-4 font-medium marker:font-medium">
                            <li className="my-2 mx-0">
                                COMPASS ERROR IS ESTABLISHED AT LEAST ONCE A
                                WATCH AND ALSO IF POSSIBLE AFTER ANY MAJOR
                                ALTERATION OF COURSE
                            </li>
                            <li className="my-2 mx-0">
                                ALL ENTRIES TO BE LEGIBLE AND WRITTEN NEATLY
                            </li>
                            <li className="my-2 mx-0">
                                WRONG ENTRIES ARE TO BE STRUCK THROUGH BY A
                                SINGLE LINE AND INITIALED BY THE WATCH OFFICER
                            </li>
                            <li className="my-2 mx-0">
                                IN THE REMARKS COLUMN WEATHER / AZIMUTH
                                INFORMATION AT THE TIME OF OBSERVATION CAN BE
                                ENTERED e.g. LOW ALTITUDE, FINE & CLEAR
                            </li>
                            <li className="my-2 mx-0">
                                STATEMENT THAT COMPASS ERROR HAS BEEN VERIFIED /
                                OBTAINED MUST ALSO BE ENTERED INTO THE DECK LOG
                                BOOK.
                            </li>
                            <li className="my-2 mx-0">
                                EACH BRIDGE WATCH OFFICER IS RESPONSIBLE FOR THE
                                CARE / PROPER RECORDING OF ERRORS AND DEVIATION
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
    const vesselStore = vesselSelectors._getStore(store);
	const globalSettings = vesselSelectors.getGlobalSettings(vesselStore);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
	const dateRange = inspectorSelectors.getDateRange(inspectorStore);
    return {
        vesselInfo,
        globalSettings,
        dateRange,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(CompassErrorCoverPage);
